import { render, staticRenderFns } from "./AllCheckUncheck.vue?vue&type=template&id=887c1978&scoped=true&"
import script from "./AllCheckUncheck.vue?vue&type=script&lang=js&"
export * from "./AllCheckUncheck.vue?vue&type=script&lang=js&"
import style0 from "./AllCheckUncheck.vue?vue&type=style&index=0&id=887c1978&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "887c1978",
  null
  
)

export default component.exports